import { SaraPromptInput } from 'src/shared/components/SaraPromptInput'
import { ONBOARDING_ELEMENT_IDS } from 'src/shared/hooks/useOnboarding'
import { useCreateOrderFromDashboardMessage } from '../hooks'

export const DashboardSearchBar = () => {
  const { createOrderWithMessage, isSubmitting } =
    useCreateOrderFromDashboardMessage()

  return (
    <div id={ONBOARDING_ELEMENT_IDS.dashboardPrompt} className="w-full">
      <SaraPromptInput
        isSubmitting={isSubmitting}
        onSubmit={createOrderWithMessage}
        startEmpty
      />
    </div>
  )
}
